import { Outlet } from 'react-router-dom';
import {
  backgroundImage,
  combineCls,
  gradientColorStops,
  height,
  overflow,
  textColor,
  twCls,
} from 'style';

export const BaseLayout = () => {
  return (
    <div
      className={combineCls(
        twCls(
          backgroundImage('bg-gradient-to-b'),
          gradientColorStops('from-white', 'to-grey-100'),
          height('h-screen'),
          textColor('text-grey-900'),
          overflow('overflow-hidden'),
        ),
        'safe-area',
      )}
    >
      <Outlet />
    </div>
  );
};
